import { render, staticRenderFns } from "./ReportAccountingDocDetails.vue?vue&type=template&id=da806e66&"
import script from "./ReportAccountingDocDetails.vue?vue&type=script&lang=js&"
export * from "./ReportAccountingDocDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports